import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ProtectedRoute = ({ children }) => {
  const { userData } = useAuth();

  // If no userData or no token, redirect to login
  if (!userData || !userData.access_token) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default ProtectedRoute;